import React from "react"
import { ScadenzaDto, AggiornaDateControlloData, ApparecchioCategory } from "../../generated"
import Actions from "../ExpirationsActions";
import Store from "../ExpirationsStore";
import { Period } from "../../common/period";
import PeriodInput from "../../common/components/periodInput";
import OpenModalButton from "../../common/components/openModalButton";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { LoadingComponent } from "../../common/components/loading";
import { AggiornaDateControlloForm } from "../../impianti/components/aggiornaDateControlloForm"
import ImpiantiHelper from "../../impianti/ImpiantiHelper";
import ExpirationsActions from "../ExpirationsActions";
import { RapportoControlloModalSelector } from "../../rapporticontrollo/components/rapportoControlloModalSelector";
import { CheckBoxNullable, CheckBox } from "../../common/components/checkBox2";
import { ExpirationMap } from "./expirationsMap";
import { Switch } from "../../common/components/switch";
import { ExpirationsTable, ExpirationLegend } from "./expirationsTable";
import ExpirationFilterStore from "./ExpirationFilterStore";
import { EditInterventoButton } from "../../interventi/components/InterventiHelpers";
//import { links } from "../../routes";
import SelectedExpirationsStore from "../SelectedExpirationsStore";
import { links } from "../../routes";
import { Link } from "../../common/components/link";
import { Dictionary } from "../../common/AbstractStores";
import { withApparecchioCateogories } from "../../impianti/withApparecchioCategories";

interface State {
    period: Period;
    expirations: ScadenzaDto[];
    selected: ScadenzaDto[];
    loading: boolean;
    onContract: boolean | null;
    mapMode: boolean;
    showPrevYears: boolean;
    scheduledExpirations: boolean | null;
}

interface Props extends RouteComponentProps {
    categories: Dictionary<ApparecchioCategory>
}

export class ExpirationsPage extends React.Component<Props, State> {
    private closeExpirationsModal = React.createRef<OpenModalButton>();
    constructor(props: Props) {
        super(props);
        const filter = ExpirationFilterStore.get();
        this.state = {
            period: filter.period,
            onContract: filter.onContract,
            mapMode: filter.mapMode,
            expirations: [],
            selected: [],
            loading: false,
            showPrevYears: filter.showPrevYears,
            scheduledExpirations: filter.scheduledExpirations,
        }
    }

    componentDidMount() {
        Store.Changed.register(this.listener);
        const { period, showPrevYears } = this.state;
        this.requestData(period, showPrevYears);
    }

    componentWillUnmount() {
        Store.Changed.unregister(this.listener);
    }

    private async requestData(period: Period, showPrevYears: boolean) {
        const stored = Store.get(Store.getKey(period.from, period.to, showPrevYears));
        if (!stored || stored.length === 0) {
            this.setState({ loading: true });
            Actions.getExpirations(period.from, period.to, showPrevYears);
        }
        else {
            this.listener();
        }
    }

    private listener = () => {
        const { period, showPrevYears } = this.state;
        const expirations = Store.get(Store.getKey(period.from, period.to, showPrevYears)) || [];
        this.setState({ expirations, loading: false });
    }

    private closeExpirations = async (data: AggiornaDateControlloData) => {
        this.closeExpirationsModal.current?.close();
        this.setState({ loading: true });
        const { selected, period, showPrevYears } = this.state;
        await ImpiantiHelper.evadiScadenze2(selected.map(x => ({ IdImpianto: x.idImpianto, IdCliente: x.idCliente })), data, this.props.categories);
        ExpirationsActions.getExpirations(period.from, period.to, showPrevYears);
        this.setState({ loading: false });
    }

    private filterOnContract = (item: ScadenzaDto, to: Date, onContract: boolean | null) => {
        if (onContract == null) return true;
        if (onContract == false) return item.contractExpiration != null && item.contractExpiration < to;
        return item.contractExpiration != null && item.contractExpiration > to;
    }

    render() {
        const { expirations, period, selected, loading, onContract, mapMode, showPrevYears, scheduledExpirations } = this.state;
        let filteredExpirations = expirations.filter(x => this.filterOnContract(x, period.to, onContract));
        filteredExpirations = scheduledExpirations != null ? filteredExpirations.filter(x => (x.idIntervento != null) === scheduledExpirations) : filteredExpirations;
        return (<div className="card">
            <div className="card-header bg-theme d-flex align-items-center justify-content-between">
                <h3 className="text-white" >Scadenze clienti</h3>
                <button type="button" className="btn btn-outline-secondary"
                    onClick={() => {
                        this.setState({ loading: true });
                        Actions.getExpirations(period.from, period.to, showPrevYears)
                    }}>
                    <i className="fas fa-sync-alt" /> Aggiorna</button>
            </div>
            <div className="card-body">
                <div className="mb-4 row d-flex d-print-none">
                    <div className="col-12 col-lg-7 py-2">
                        <PeriodInput
                            labelFrom="Scadenze dal"
                            labelTo="Scadenze al"
                            period={period}
                            onChange={period => {
                                ExpirationFilterStore.set(period, onContract, mapMode, showPrevYears, scheduledExpirations)
                                this.setState({ period }, () => this.requestData(period, showPrevYears));

                            }}
                        />
                    </div>
                    <div className="col-12 col-lg-1 py-2">
                        <div><label className="form-label">Conf. scadenze</label></div>
                        <Link className="btn btn-outline-info" to={links.expirationsSettings}><i className="fas fa-cog me-2" /> Personalizza</Link>
                    </div>
                    <div className="col-12 col-lg-4 d-flex flex-column py-2">
                        <div className="mt-auto mb-2">
                            <CheckBox
                                label="Mostra anche anni precedenti"
                                checked={showPrevYears}
                                onChange={showPrevYears => {
                                    ExpirationFilterStore.set(period, onContract, mapMode, showPrevYears, scheduledExpirations)
                                    this.setState({ showPrevYears }, () => this.requestData(period, showPrevYears));
                                }}
                            />
                        </div>
                        <div className="mt-auto mb-2">
                            <CheckBoxNullable
                                label="Interventi Pianificati"
                                checked={scheduledExpirations}
                                descriptions={{ checked: "Solo pianificati", unchecked: "Non pianificati", half: "Ignora" }}
                                onChange={checked => {
                                    ExpirationFilterStore.set(period, onContract, mapMode, showPrevYears, checked)
                                    this.setState({ scheduledExpirations: checked })
                                }}
                            />
                        </div>
                        <div className="mt-auto mb-2">
                            <CheckBoxNullable
                                label="Contratto di manutenzione"
                                checked={onContract}
                                descriptions={{ checked: "In contratto", unchecked: "Senza contratto", half: "Non controllare" }}
                                onChange={onContract => {
                                    ExpirationFilterStore.set(period, onContract, mapMode, showPrevYears, scheduledExpirations)
                                    this.setState({ onContract })
                                }}
                            />
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-wrap mb-3">
                    <ExpirationLegend />
                    <div className="me-2 ms-auto">
                        <Switch
                            label="Visualizza su mappa"
                            checked={mapMode}
                            onChange={mapMode => {
                                ExpirationFilterStore.set(period, onContract, mapMode, showPrevYears, scheduledExpirations)
                                this.setState({ mapMode })
                            }}
                        />
                    </div>
                </div>
                <LoadingComponent isLoading={loading}>
                    {mapMode
                        && <ExpirationMap expirations={expirations} />
                        || <ExpirationsTable
                            data={filteredExpirations}
                            selectedItems={this.state.selected}
                            onSelectRow={clickedItem => this.setState({
                                selected: this.state.selected.indexOf(clickedItem) > -1
                                    ? this.state.selected.filter(s => s != clickedItem)
                                    : [...this.state.selected, clickedItem]
                            })}
                            onSelect={selected => {
                                SelectedExpirationsStore.scadenze = selected;
                                this.setState({ selected });
                            }}
                        />
                    }
                </LoadingComponent>
                {
                    selected.length > 0 && <div className="w-100 card sticky-top d-none d-md-flex" style={{
                        position: "sticky",
                        bottom: 10,
                        padding: 5,
                        zIndex: 2,
                        background: "white",
                    }}>
                        <div className="w-100 card-body">
                            <h3>Impianti selezionati: {selected.length}</h3>
                            <OpenModalButton
                                ref={this.closeExpirationsModal}
                                title="Evadi scadenze"
                                className="btn btn-success me-2"
                                modalContent={
                                    <AggiornaDateControlloForm
                                        impiantiIds={selected.map(x => x.idImpianto)}
                                        onSubmit={this.closeExpirations}
                                    />
                                }
                            >
                                <i className="fas fa-tasks me-2" /> Evadi scadenze
                            </OpenModalButton>
                            {selected.some(x => x.cell || x.email) && <Link
                                className="btn btn-info me-2 text-white"
                                to={links.notifications}
                            >
                                Invio e-mail/sms
                            </Link>}
                            {selected.length === 1 &&
                                <>
                                    <RapportoControlloModalSelector
                                        idCliente={selected[0].idCliente}
                                        idImpianto={selected[0].idImpianto}
                                    />
                                    <EditInterventoButton
                                        title="Intervento"
                                        className="ms-2 btn btn-outline-secondary"
                                        idIntervento={selected[0].idIntervento}
                                        idCliente={selected[0].idCliente ?? undefined}
                                        idImpianto={selected[0].idImpianto ?? undefined}
                                    >
                                        <i className="fas fa-plus" /> <i className="fas fa-truck me-2" /> Intervento
                                    </EditInterventoButton>
                                </>}
                        </div>
                    </div>
                }
                {
                    selected.length > 0 && <div className="w-100 card sticky-bottom d-flex d-md-none" style={{
                        zIndex: 2,
                        background: "white",
                    }}>
                        <div className="card-footer w-100 pb-1">
                            <div className="d-flex flex-wrap justify-content-around">
                                <OpenModalButton
                                    ref={this.closeExpirationsModal}
                                    title="Evadi scadenze"
                                    className="btn btn-outline-success d-flex flex-column align-items-center justify-content-center"
                                    style={{ width: 52, height: 52 }}
                                    modalContent={
                                        <AggiornaDateControlloForm
                                            impiantiIds={selected.map(x => x.idImpianto)}
                                            onSubmit={this.closeExpirations}
                                        />
                                    }
                                >
                                    <i className="fas fa-tasks fa-lg" />
                                    <span style={{ fontSize: "0.65em" }} className="text-wrap">Evadi scadenze</span>
                                </OpenModalButton>

                                {selected.length === 1 &&
                                    <>
                                        <RapportoControlloModalSelector
                                            className="btn btn-outline-secondary d-flex flex-column align-items-center justify-content-center"
                                            style={{ width: 52, height: 52, fontSize: "0.65em" }}
                                            idImpianto={selected[0].idImpianto}
                                            idCliente={selected[0].idCliente}
                                            iconClassName="fas fa-print fa-lg" />
                                        <EditInterventoButton
                                            title="Intervento"
                                            className="btn btn-outline-success d-flex flex-column align-items-center justify-content-center"
                                            style={{ width: 52, height: 52 }}
                                            idIntervento={selected[0].idIntervento}
                                            idCliente={selected[0].idCliente ?? undefined}
                                            idImpianto={selected[0].idImpianto ?? undefined}
                                        >
                                            <i className="fas fa-truck" />
                                            <span style={{ fontSize: "0.65em" }} className="text-wrap">Pianifica intervento</span>
                                        </EditInterventoButton>
                                    </>
                                }
                            </div>
                            <small>Impianti selezionati: {selected.length}</small>
                        </div>
                    </div>
                }
            </div>
        </div >);
    }
}

const cmp1 = withApparecchioCateogories(ExpirationsPage)(x => x.allByKey(), "categories")
export default withRouter(cmp1);